
// Definición de defaults

export const defaultTabValidation : TabValidationProps = {
    idDemandaInicial:   0,
    idPromocion:        0,
    idExhortoRecibido:  0,
    idAmparo:           0,
    idExpediente:       0,
    idIrregular:        0,
}

// Creación de interfaces

export interface TabValidationProps {
    idDemandaInicial:   number;
    idPromocion:        number;
    idExhortoRecibido:  number;
    idAmparo:           number;
    idExpediente:       number;
    idIrregular:        number;
}